import List from './List';
import Item from './Item';

const Components = {
    List : List,
    Item : Item
}

export default Components;